module.exports = __webpack_public_path__ + "img/border_3.52a20743.png";